import { default as Intl } from "intl";
import "intl/locale-data/jsonp/pt-BR";

const maskMoney = (value, digits = 2) =>
  new Intl.NumberFormat("pt-BR", { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
    parseFloat(value)
  );

// 000.000.000-00
const maskCPF = (value) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

const validarCPF = (cpf) => {
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;

  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(10))) return false;

  return true;
};

// (00) 00000-0000
const maskPhone = (value) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .replace(/(-\d{4})(\d+?)$/, "$1");
};

// 00000-000
const maskCEP = (value) => {
  return value.replace(/\D/g, "").replace(/^(\d{5})(\d{3})+?$/, "$1-$2");
};

// 00/00/0000
const maskDate = (value) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1");
};

// Aceita apenas que letras sejam digitadas
const maskOnlyLetters = (value) => {
  return value.replace(/[0-9!@#¨$%^&*)(+=._-]+/g, "");
};

// Aceita apenas números
const maskOnlyNumbers = (value) => {
  return value.replace(/[^0-9]/g, "");
};

const parseToInt = (value) => {
  var parsedValue = parseInt(value);
  return isNaN(parsedValue) ? 0 : parsedValue;
};

const parseToFloat = (value) => {
  var parsedValue = parseFloat(value);
  return isNaN(parsedValue) || !isFinite(parsedValue) ? 0 : parsedValue;
};

const randomInt = (max) => {
  return Math.floor(Math.random() * max) + 1;
};

export {
  maskOnlyNumbers,
  maskCPF,
  validarCPF,
  maskOnlyLetters,
  maskDate,
  maskCEP,
  maskPhone,
  maskMoney,
  parseToInt,
  parseToFloat,
  randomInt,
};
